<script setup lang="ts">
  import { useSavingIndicatorStore } from '@/store/savingIndicatorStore'
  import { computed } from 'vue'

  const savingIndicatorStore = useSavingIndicatorStore()

  const show = computed(() => savingIndicatorStore.isSaving)
</script>

<template>
  <div
    v-if="show"
    class="inline-block size-6 animate-spin rounded-full border-[6px] border-current border-t-transparent
      text-purple-600 dark:text-purple-500"
    role="status"
    aria-label="loading"
  >
    <span class="sr-only">Saving...</span>
  </div>
</template>

<style scoped></style>
